import type { LucideIcon } from "lucide-react";
import type { IconProps } from "./props";

/**
 * Two optical sizes. `md` is the default 18px glyph; `sm` is the 12px glyph for
 * dense spots (badges, table cells, inline metadata). Call sites still pick the
 * rendered size with one `size-*` class; this only sets the intrinsic size.
 */
const SIZES = { sm: 12, md: 18 } as const;

/**
 * Stroke width in screen pixels. `data-teral-icon` opts every shape into
 * `vector-effect: non-scaling-stroke` (see @teral/ui/theme.css), so a glyph
 * keeps a 1.5px line whether it renders at 12px or 32px.
 */
const STROKE = 1.5;

export function createIcon(
  Glyph: LucideIcon,
  displayName: string,
  size: keyof typeof SIZES = "md",
  defaults: IconProps = {},
) {
  function Icon(props: IconProps) {
    const { ref, ...rest } = props;
    return (
      <Glyph
        ref={ref as React.Ref<SVGSVGElement>}
        size={SIZES[size]}
        strokeWidth={STROKE}
        data-teral-icon=""
        {...defaults}
        {...(rest as Omit<React.ComponentProps<LucideIcon>, "ref">)}
      />
    );
  }
  Icon.displayName = displayName;
  return Icon;
}
